import React, { useEffect } from 'react';
import CreateFolderOrFileModal from './CreateFolderOrFileModal';
import { useGetFoldersAndFiles } from '../../services/folders_and_files.service';
import { Table } from '../../util';
import { useTranslation } from 'react-i18next';
import { createTimezonedDate } from '../../util/date';
export default function FileOnlyList(_ref) {
  let {
    showModal,
    setShowModal,
    folderId,
    modelId,
    modelType,
    onFilesChanged
  } = _ref;
  const [setFolders, setFiles, setCurrentFolderId, currentFolderId, folders, files, currentPath] = useGetFoldersAndFiles(modelId, modelType, folderId, true);
  const {
    t
  } = useTranslation();
  useEffect(() => {
    onFilesChanged(files);
  }, [files, onFilesChanged]);
  const filesSortedByDate = files.sort((a, b) => a.created_at > b.created_at ? -1 : 0);
  const headers = [{
    text: ''
  }, {
    text: t('date')
  }, {
    text: t('name')
  },
  // { text: t('notes') },
  {
    text: t('uploaded_by')
  }];
  const rows = filesSortedByDate.map(file => ({
    key: file.id,
    columns: [/*#__PURE__*/React.createElement("span", {
      class: "material-icons",
      style: {
        color: 'rgb(0, 120, 185)'
      }
    }, "description"), createTimezonedDate(file.created_at).toCustomLocaleDateString(), file.name,
    // file.notes,
    file.uploaded_by]
  }));
  console.log('rows; ', rows);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Table, {
    headers: headers,
    rows: rows
  }), /*#__PURE__*/React.createElement(CreateFolderOrFileModal, {
    route: 'folder_files',
    show: showModal,
    onHide: () => setShowModal(false),
    currentFolderId: folderId,
    allData: files,
    setAllData: setFiles,
    targetModelId: modelId,
    type: modelType
  }));
}